//components
import { PillLink } from '@/containers-ai/Buttons';

//styles
import { EndCTASection, Title, TitleHighlight } from './EndCTA.styles';
import { Container } from '@/components/Grid';

export function EndCTA({ variant = 'top' }) {
  return (
    <EndCTASection
      id={variant === 'top' ? 'cta' : undefined}
      $variant={variant}
    >
      <Container>
        <Title>
          Tell us the workflow that bothers you most.{' '}
          <TitleHighlight>We&rsquo;ll run it.</TitleHighlight>
        </Title>
        <PillLink
          href="/contact/#contact-form"
          style={{ fontSize: '16px', padding: '16px 32px' }}
          className="qlf-btn-3"
        >
          Book a working session &#8594;
        </PillLink>
      </Container>
    </EndCTASection>
  );
}
